/* Gift finder: loads the live catalogue once (when the section comes near), then picks three.
   Tracking (26 Oct, anonymous): counts seen, used and picked at the delivery worker (/gf), and notes the
   choice on the cart ("Gift finder", under Additional details on the order) so Flow can tag the order gift-finder. */
(function () {
  'use strict';
  function list(s) { return String(s || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); }
  function any(a, b) { return b.some(function (x) { return a.indexOf(x) > -1; }); }
  function setup(sec) {
    if (!sec || sec._f) return; var B = window.BBC; if (!B) return; sec._f = 1;
    var FRESH = list(sec.getAttribute('data-fresh')), LAST = list(sec.getAttribute('data-lasting')), HAMP = list(sec.getAttribute('data-hamper')), SKIP = list(sec.getAttribute('data-skip'));
    var LOW = +sec.getAttribute('data-low') || 10000, HIGH = +sec.getAttribute('data-high') || 20000;
    var BUD = { low: [0, LOW - 1], mid: [LOW, HIGH], high: [HIGH + 1, 1e9] };
    var sel = { occ: '', bud: 'mid', typ: 'fresh' }, P = null, loading = false;
    var first = sec.querySelector('[data-group="occ"] [aria-checked="true"]'); if (first) sel.occ = first.getAttribute('data-v');
    var GF = 'https://blossom-delivery.chau-4c5.workers.dev/gf', sid = Math.random().toString(36).slice(2, 10), shown = [], used = 0, later, picked = 0;
    try { picked = +(sessionStorage.getItem('bbc-gf') || 0); } catch (err) {}

    function said(g) { var b = sec.querySelector('[data-group="' + g + '"] [aria-checked="true"]'); return b ? b.textContent.replace(/\s+/g, ' ').trim() : ''; }
    function choice() { return [said('occ'), said('bud'), said('typ')].join(', '); }
    function beat(e, x) {
      try {
        var d = { e: e, s: sid, occ: sel.occ, bud: sel.bud, typ: sel.typ, p: location.pathname }, k;
        for (k in x || {}) d[k] = x[k];
        d = JSON.stringify(d);
        if (!(navigator.sendBeacon && navigator.sendBeacon(GF, d))) fetch(GF, { method: 'POST', body: d, keepalive: true, mode: 'no-cors' }).catch(function () {});
      } catch (err) {}
    }
    function note(v) {
      return fetch(B.routes.cart + '/update.js', { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { 'Gift finder': v.slice(0, 250) } }) }).catch(function () {});
    }
    function use() {
      if (!used) { used = 1; beat('use'); }
      // a pick made earlier in this visit is never replaced by "Used"
      clearTimeout(later); later = setTimeout(function () { if (!picked) note('Used: ' + choice()); }, 1500);
    }

    function kind(c, x) {
      if (any(c, LAST)) return 'lasting';
      if (any(c.concat(x), FRESH)) return 'fresh';
      if (any(c, HAMP)) return 'hamper';
      return '';
    }
    function occasions(p) {
      var tagged = p.g.map(function (t) { var m = String(t).toLowerCase().match(/^occasion[-:_\s]+(.+)$/); return m ? m[1].replace(/\s+/g, '') : null; }).filter(Boolean);
      if (tagged.length) return tagged;
      var t = p.t.toLowerCase(), c = p.c, o = {}, g = p.g.map(function (x) { return String(x).toLowerCase(); });
      var sig = any(c, ['signature-range', 'signature-x']), bsp = c.indexOf('bbco-bespoke') > -1, mkt = c.indexOf('market-bunches') > -1;
      var fresh = sig || bsp || mkt || p.k === 'fresh', pres = p.k === 'lasting', baby = c.indexOf('baby-gifts') > -1;
      var hamp = c.indexOf('hampers') > -1, treats = c.indexOf('chocomama') > -1, drinks = c.indexOf('gifts') > -1, home = c.indexOf('new-scent-collection') > -1, pop = c.indexOf('pop-mart') > -1, books = c.indexOf('books') > -1;
      if (baby) return ['baby'];
      if (sig || /rose|love|cupid|xoxo|heart|teddy|kiss/.test(t) || any(g, ['valentines', 'valentine26', "valentine's collection", 'roses'])) { o.love = 1; o.anniversary = 1; }
      if (fresh || pres || hamp || treats || drinks || pop || home || /teddy|bear|balloon/.test(t)) o.birthday = 1;
      if (bsp || mkt || hamp || treats || drinks || home || /bucket|single|one and only/.test(t)) o.thanks = 1;
      if (/white|blake|tyler|blair|lil(y|ies)|orchid|peace lily|native|serenity|hydrangea|gourmet|sympathy/.test(t) || pres) o.sympathy = 1;
      if (mkt || bsp || home || pop || books || treats || pres || /single|one and only|candle/.test(t)) o.just = 1;
      if (fresh || hamp || treats || /plant|orchid|lily/.test(t)) o.getwell = 1;
      if (sig && /mini|bucket|one and only|single/.test(t)) { o.thanks = 1; o.just = 1; }
      return Object.keys(o);
    }
    function load() {
      if (P || loading) return; loading = true;
      // no Accept: application/json header, or Shopify answers with its own collection JSON instead of the template
      fetch(sec.getAttribute('data-src'))
        .then(function (r) { return r.text(); })
        .then(function (txt) {
          var raw = JSON.parse(txt); if (!Array.isArray(raw)) throw new Error('finder data'); raw = raw.filter(Boolean);
          P = raw.filter(function (p) { return !any(p.c, SKIP) && p.v.length; }).map(function (p) { p.k = kind(p.c, p.g.concat([p.h])); p.o = occasions(p); return p; }).filter(function (p) { return p.k; });
          run();
        })
        .catch(function () { loading = false; sec.querySelector('[data-list]').innerHTML = '<li class="results-note">Picks could not load. <a href="' + B.routes.root + 'collections/all">See everything in the studio</a>.</li>'; });
    }
    function run() {
      if (!P) { load(); return; }
      var b = BUD[sel.bud];
      var all = P.map(function (p) { var fit = p.v.filter(function (v) { return v[1] >= b[0] && v[1] <= b[1]; })[0]; return { p: p, fit: fit, occ: p.o.indexOf(sel.occ) > -1, typ: p.k === sel.typ }; });
      var exact = all.filter(function (x) { return x.occ && x.typ && x.fit; });
      var out = exact.slice(), note = '';
      if (out.length < 3) {
        var gap = function (x) { return x.fit ? 0 : Math.min.apply(null, x.p.v.map(function (v) { return v[1] < b[0] ? b[0] - v[1] : v[1] - b[1]; })); }, occN = all.filter(function (x) { return x.occ; }).length, more = all.filter(function (x) { return out.indexOf(x) < 0 && (x.occ || (occN < 3 && x.typ)); })
          .sort(function (a, c) { return (c.occ * 4 + c.typ * 2 + !!c.fit) - (a.occ * 4 + a.typ * 2 + !!a.fit) || gap(a) - gap(c); });
        out = out.concat(more).slice(0, 3); if (!exact.length) note = 'Nothing ticks all three boxes, so here are our closest picks.';
      }
      sec.querySelector('[data-count]').textContent = exact.length + ' match' + (exact.length === 1 ? '' : 'es');
      var n = sec.querySelector('[data-note]'); n.hidden = !note; n.textContent = note;
      shown = out;
      sec.querySelector('[data-list]').innerHTML = out.map(function (x, i) {
        var p = x.p, v = x.fit || p.v[0], lab = p.n > 1 && v[0] !== 'Default Title' ? String(v[0]).replace(/\s*\(pictured\)\s*/i, '') + ', ' : '';
        return '<li><a class="res" data-gf="' + i + '" style="animation-delay:' + (Math.min(i, 6) * 80) + 'ms" href="' + B.esc(p.u) + (x.fit ? '?variant=' + v[2] : '') + '">' +
          (p.i ? '<span class="res-ph fr"><img src="' + B.esc(p.i) + '" alt="" width="96" height="120" loading="lazy"></span>' : '<span class="res-ph noimg"><svg aria-hidden="true"><use href="#emblem"/></svg></span>') +
          '<span><b>' + B.esc(p.t) + '</b><small>' + (x.fit ? B.esc(lab) + B.money(v[1]) : (p.v.length > 1 ? 'From ' : '') + B.money(p.v[0][1])) +
          '</small><span class="go">View <svg aria-hidden="true"><use href="#i-arrow"/></svg></span></span></a></li>';
      }).join('');
    }
    Array.prototype.forEach.call(sec.querySelectorAll('[data-group]'), function (g) {
      g.addEventListener('click', function (e) { var b = e.target.closest('.chip'); if (!b) return; B.radio(g, b); sel[g.getAttribute('data-group')] = b.getAttribute('data-v'); run(); use(); });
    });
    // links elsewhere on the page can preset the finder: data-find-typ="lasting" etc.
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-find-typ],[data-find-occ]'); if (!a) return;
      ['typ', 'occ'].forEach(function (k) { var v = a.getAttribute('data-find-' + k); if (!v) return; var b = sec.querySelector('[data-group="' + k + '"] [data-v="' + v + '"]'); if (b) { B.radio(b.parentNode, b); sel[k] = v; } });
      run(); use();
    });
    sec.querySelector('[data-list]').addEventListener('click', function (e) {
      var a = e.target.closest('a.res'), i = a ? +a.getAttribute('data-gf') : -1, x = shown[i]; if (!x) return;
      picked = 1; clearTimeout(later);
      try { sessionStorage.setItem('bbc-gf', '1'); } catch (err) {}
      beat('pick', { i: i, h: String(x.p.u).split('/products/').pop(), x: !!(x.occ && x.typ && x.fit) });
      var done = note('Picked: ' + String(x.p.t).replace(/\*NEW\*/i, '').trim() + ' (' + choice() + ')');
      if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      // wait for the cart note (0.4 s at most) so a first visit's new cart is saved before the page changes
      e.preventDefault();
      var n = 0, go = function () { if (!n++) location.href = a.href; };
      done.then(go); setTimeout(go, 400);
    });
    if ('IntersectionObserver' in window) {
      var seen = new IntersectionObserver(function (en) { if (en.some(function (x) { return x.isIntersecting; })) { seen.disconnect(); beat('seen'); } }, { rootMargin: '0px 0px -40% 0px' });
      seen.observe(sec);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); load(); } }, { rootMargin: '600px 0px' });
      io.observe(sec);
      setTimeout(load, 5000); // in case the page is opened part way down
    } else load();
  }
  function all() { Array.prototype.forEach.call(document.querySelectorAll('[data-finder]'), setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
